import React, {useReducer} from 'react'
import {setIsLoading, setLoading, updateStats} from "./appSlice";
import store from "../../store/store";
import Api from "../../Services/Api";
import {check} from "../users/Users";


export const getStats = async (data) => {

    await Api.stats(data).then(r => {
        let {revenueThisMonth, revenueLastMonth, stats30, stats, supplyFeedId} = r
        let statsData = {
            thisMonth: revenueThisMonth,
            lastMonth: revenueLastMonth,
            graph: stats30,
            query: stats,
            startDate: data?.start?.toISOString(),
            endDate: data?.end.toISOString(),
            supplyFeedId: supplyFeedId ? supplyFeedId : null
        }
        store.dispatch(updateStats(statsData))

    });
}

export const ready = async (data) => {
    store.dispatch(setLoading(data))
}

export const isLoading = async (status) => {
    store.dispatch(setIsLoading(status))
}

export const init = async (data) => {

    await isLoading(true)
    const end = new Date()
    const start = new Date(new Date(end).setDate(end.getDate() - 15))

    await check().then(r => {
            if (r) {
                getStats({start: start, end: end}).then(r => {
                    isLoading(false)
                    // ready(true)
                })
            }
        }
    )
}








